import React from 'react';

const CancellationAndRefunds = () => {
  return (
   <>
   <section  className="mt-16 md:ml-72 " >
   <div className="flex flex-col justify-center items-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full text-center">
        <h1 className="text-3xl font-semibold mb-4 text-gray-800">Cancellation and Refunds</h1>
        <p className="text-gray-600">
          Currently, we are not providing cancellations and refunds. However, we will introduce these features when we add more plans in the future.
        </p>
      </div>
    </div>
   </section>
   </>
  );
};

export default CancellationAndRefunds;
